<template lang="pug">
.remit-data-list
  p.remit-data-list__empty(v-if="!entries.length") No hay remites guardados.

  .remit-data-list__item(v-for="(entry, index) in entries" :key="entryKey(entry, index)")
    .remit-data-list__item-header
      span.remit-data-list__item-title Remite {{ entries.length - index }}
      span.remit-data-list__item-date(v-if="entry.createdAt") {{ dateName(entry.createdAt) }} - {{ time(entry.createdAt) }}

    .remit-data-list__body
      .remit-data-list__field
        span.remit-data-list__label Nombre
        span.remit-data-list__value.capitalize(:class="valueClass(entry, 'name', index)") {{ entry.name || '—' }}

      .remit-data-list__field
        span.remit-data-list__label Teléfono
        span.remit-data-list__value(:class="valueClass(entry, 'phone', index)") {{ entry.phone || '—' }}

      .remit-data-list__field
        span.remit-data-list__label Ubicación
        span.remit-data-list__value.capitalize(:class="valueClass(entry, 'location', index)") {{ locationLabel(entry) }}

      .remit-data-list__field
        span.remit-data-list__label Dirección
        span.remit-data-list__value.capitalize(:class="valueClass(entry, 'address', index)") {{ entry.address || '—' }}

    .remit-data-list__meta(v-if="entry.generatedBy")
      span.remit-data-list__meta-label Generado por
      shNameUser.remit-data-list__meta-user(:dni="entry.generatedBy")
</template>

<script>
import mFilters from '@/mixins/filters'
import shNameUser from '@/components/elements/NameUser'
import { getRemitReferenceForEntry, remitFieldDiffers } from '@/helpers/remit'

export default {
  name: 'RemitDataList',

  mixins: [mFilters],

  components: { shNameUser },

  props: {
    order: {
      type: Object,
      default: null
    },
    record: {
      type: Object,
      default: null
    }
  },

  computed: {
    recordData () {
      return this.record || this.order
    },

    entries () {
      return ((this.recordData && this.recordData.remitData) || []).slice().reverse()
    }
  },

  methods: {
    entryKey (entry, index) {
      const createdAt = entry.createdAt || ''
      return `${createdAt}-${index}`
    },

    locationLabel (entry) {
      const parts = [entry.location, entry.department].filter(Boolean)
      return parts.length ? parts.join(' - ') : '—'
    },

    valueClass (entry, field, displayIndex) {
      const reference = getRemitReferenceForEntry(this.recordData, displayIndex)

      return {
        'remit-data-list__value--outdated': remitFieldDiffers(entry, reference, field)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.remit-data-list
  display flex
  flex-direction column
  gap 2rem

.remit-data-list__empty
  margin 0
  font-size .95rem
  opacity .7

.remit-data-list__item
  padding 0

.remit-data-list__item-header
  display flex
  flex-wrap wrap
  align-items baseline
  justify-content space-between
  gap .5rem
  margin-bottom .75rem

.remit-data-list__item-title
  font-size 1rem
  font-weight 600
  text-transform uppercase

.remit-data-list__item-date
  font-size .85rem
  color var(--color-placeholder)

.remit-data-list__body
  padding .85rem 1rem
  background var(--color-light)
  border 1px solid var(--color-border)
  border-radius .35rem

.remit-data-list__field
  display grid
  grid-template-columns 6.5rem minmax(0, 1fr)
  gap .35rem .75rem
  margin-bottom .35rem
  font-size .95rem
  line-height 1.35

  &:last-child
    margin-bottom 0

.remit-data-list__meta
  display flex
  flex-wrap wrap
  align-items baseline
  gap .35rem .5rem
  margin-top .85rem
  font-size .8rem
  color var(--color-placeholder)

.remit-data-list__meta-label
  letter-spacing .02em

.remit-data-list__meta-user
  font-size .85rem
  opacity .85

.remit-data-list__label
  color var(--color-placeholder)
  text-transform uppercase
  font-size .8rem

.remit-data-list__value
  word-break break-word

.remit-data-list__value--outdated
  color var(--color-red)
  text-decoration line-through
</style>



// WEBPACK FOOTER //
// src/components/elements/remit/RemitDataList.vue